import corporateRequest from 'utils/corporateRequest'

export const getSingleEligibleRoleDetails =
  (JobID,studentId) => async (dispatch, getState) => {
    try {
      const res = await corporateRequest.get(
        `/corporate/eligiblerole/${JobID}/${studentId}`
      )
      return res?.data?.data
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }
